module.exports = "/_next/static/images/c2c697f50cbe89ad60270dc514326a39-estadao-logo.png.webp";